import './GuestHomePage.styles.scss';

import React, { useContext } from 'react';
import DocTitleScrollTop from '../../utils/DocTitleScrollTop';
import RegisterForm from './RegisterForm';

import pickBkgClass from '../../utils/pickBkgClass';
import MyThemeContext from '../../contexts/theme-context/ThemeProviderContext';
import starPatternDark from '../../assets/imgs/bkgs/star-pattern.svg';
import starPatternLight from '../../assets/imgs/bkgs/star-pattern-light.svg';

const GuestHomePage = () => {
	DocTitleScrollTop('Home-Guest');
	const { themeType, themeName } = useContext(MyThemeContext);

	return (
		<div
			className="myPage guestHomePage"
			style={{
				backgroundImage:
					themeType === 'light'
						? `url(${starPatternLight})`
						: `url(${starPatternDark})`
			}}
		>
			<div className={`overlay ${pickBkgClass(themeName, 'hard')}`}></div>
			<div className="mfaContainer">
				<div className="homepageContent">
					<div
						className={`mainPDiv ${themeType} ${pickBkgClass(
							themeName,
							'hard'
						)}`}
					>
						<h1>Remember Writing?</h1>
						<p>
							Are your sick of short tweets and impersonal "shared" posts that
							are reminiscent of the late 90's email forwards? We believe
							getting back to actually writing is the key to enjoy the internet
							again.
						</p>
					</div>

					<RegisterForm />
				</div>
			</div>
		</div>
	);
};

export default GuestHomePage;
